import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Breadcrumb, Button, Modal, OverlayTrigger, Tab, Tabs, Badge, Form } from 'react-bootstrap';
import { BiCheckCircle, BiXCircle, BiCollapseVertical, BiChevronDown, BiX, BiCheck, BiChevronUp, BiInfoCircle, BiSolidCircle, BiPlus, BiPencil, BiTrash } from 'react-icons/bi';
import { BsTagsFill } from "react-icons/bs";
import { withTranslation, useTranslation } from 'react-i18next';
import { BsEyeFill } from "react-icons/bs";
import '../MaterialityAssessment.scss';
import { LoaderContext } from '../../../../../App';
import MaterialIssueService from '../../../../../core/service/MaterialIssueService';
import environmental from '../../../../../images/environment.png';
import social from '../../../../../images/Social_icon.png';
import governance from '../../../../../images/governance_icon.png';
import QuestionService from "../../../../../core/service/QuestionService";
import { LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY } from '../../../../../core/constants/common';
import { toast } from "react-toastify";
import Utils from '../../../../../core/utilities/Utils';
import CompanyService from '../../../../../core/service/CompanyService';
import ConfirmationModal from '../../../../../components/ConfirmationModal/ConfirmationModal';
import MaterialityImpactSelectionModal from './MaterialityImpactSelectionModal';
import MaterialIssuesLibraryModal from './MaterialIssuesLibraryModal';
import custom_tag from '../../../../../images/tags.png';
import CustomTopicFilter from '../../../../../components/CustomTopicFilter/CustomTopicFilter';
import CustomTopicFilterStatus from '../../../../../components/CustomTopicFilter/CustomTopicFilterStatus';
const MaterialIssuesLibrary = ({ t, filter, selectedData, omittedData, viewType, onSuccess, status, onData, filteredData }) => {

    const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
    const companyId = lsDat.profile.company.id;
    const lsCompanyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
    const currentCompanyId = JSON.parse(localStorage.getItem('companyInfo'))?.id;
    const { setLoaderDisplay } = useContext(LoaderContext);
    const [topics, setTopics] = useState([]);
    const [topicsCopy, setTopicsCopy] = useState([]);
    const [topicVisiblity, setTopicVisiblity] = useState({});
    const [selectedTopics, setSelectedTopics] = useState({ topicIds: [], topics: [] });
    const { k, i18n } = useTranslation();

    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [showSelectModal, setShowSelectModal] = useState(false);
    const [showOmitModal, setShowOmitModal] = useState(false);
    const [show3, setShow3] = useState(false);

    const handleDescShow = () => setShowDescriptionModal(true);
    const handleDescClose = () => { setShowDescriptionModal(false); resetValues() };

    const handleShowSelect = () => setShowSelectModal(true);
    const handleCloseSelect = () => { setShowSelectModal(false); resetValues() };

    const handleShowOmit = () => setShowOmitModal(true);
    const handleCloseOmit = () => { setShowOmitModal(false); resetValues() };

    const handleShowlibrary = () => setShow3(true);
    const handleCloselibrary = () => setShow3(false);

    const [financialImpact, setFinancialImpact] = useState({
        type: "FINANCIAL",
        range: "",
        likelihood: "",
        reason: ""
    })
    const [materialityImpact, setMaterialityImpact] = useState({
        type: "IMPACT",
        likelihood: "",
        scale: "",
        scope: "",
        irremediability: "",
        reason: ""
    })
    const [importanceImpact, setImportanceImpact] = useState({
        type: "IMPORTANCE",
        scale: "",
        reason: ""
    })
    const [materialityType, setMaterialityType] = useState(lsCompanyInfo.materialityType == 'SINGLE' ? 'Single' : 'Double');
    const [selectedSubSubTopic, setSelectedSubSubTopic] = useState({});
    const [omitReason, setOmitReason] = useState('');
    const [topicDetails, setTopicDetails] = useState({});
    const [omitType, setOmitType] = useState('');
    const [selectedDataDetails, setSelectedDataDetails] = useState([]);
    const [omittedDataDetails, setOmittedDataDetails] = useState([]);
    const [showDetailsTab, setShowDetailsTab] = useState(false);
    const [validatedGroupSelect, setValidatedGroupSelect] = useState(false);
    const [validatedGroupOmit, setValidatedGroupOmit] = useState(false);
    const [titlename, setTitlename] = useState('');
    const [primaryLanguageCode, setPrimaryLanguageCode] = useState('');
    const typeOrder = { ENVIRONMENTAL: 1, SOCIAL: 2, GOVERNANCE: 3 };
    const companyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
    const [activeTab, setActiveTab] = useState('selectedBox');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [bulkOmitData, setBulkOmitData] = useState({});
    const [bulkOmitType, setBulkOmitType] = useState({});

    // Modal state for topic management
    const [showTopicModal, setShowTopicModal] = useState(false);
    const [modalAction, setModalAction] = useState('');
    const [selectedParentTopic, setSelectedParentTopic] = useState(null);
    const [selectedParentSubTopic, setSelectedParentSubTopic] = useState(null);
    const [selectedTopicForEdit, setSelectedTopicForEdit] = useState(null);

    // Delete confirmation modal state
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteTopicData, setDeleteTopicData] = useState(null);
    const [deleteType, setDeleteType] = useState('');

    // Own Topics toggle state
    const [showOwnTopicsOnly, setShowOwnTopicsOnly] = useState(false);
    const [filterDisplay, setFilterDisplay] = useState(false);

    useEffect(() => {
        getCompanyLanguages();
        getAllTopics();
    }, [filter]);

    useEffect(() => {
        setTopics(filteredData)
    }, [filteredData]);

    const transformObject = (obj) => {
        const transformedObj = { ...obj };
        // Add the translated values to the main object based on languageCode
        if (obj.localizedContents && obj.localizedContents.length > 0) {
            obj.localizedContents.forEach((item) => {
                if (item.fieldName === 'name') {
                    transformedObj[item.languageCode] = item.translatedValue;
                } else if (item.fieldName === 'description') {
                    transformedObj[`${item.languageCode}_description`] = item.translatedValue;
                }
            });
        }
        // Recursively process the children objects
        if (obj.children && obj.children.length > 0) {
            transformedObj.children = obj.children.map((child) => transformObject(child));
        }

        return transformedObj;
    };

    const getAllTopics = () => {
        setLoaderDisplay(true);
        MaterialIssueService.getParentTopics(filter.category, companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL', true)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;

                setTopicVisiblity({});
                // const sortedData = res.data.data.sort((a, b) => {
                //     if (typeOrder[a.category] < typeOrder[b.category]) return -1;
                //     if (typeOrder[a.category] > typeOrder[b.category]) return 1;
                //     return a.name.localeCompare(b.name);
                // });

                const transformedData = res.data.data.map((obj) => transformObject(obj));

                const t = JSON.parse(JSON.stringify(topicVisiblity));
                transformedData.forEach(topic => {
                    topic.children.forEach(element => {
                        t[element.id] = false;
                    });
                });
                setTopicVisiblity(t);

                setTopics(transformedData ?? []);
                setTopicsCopy(transformedData ?? []);
                onData(transformedData);

                getAllSelectedData();
                getAllOmittedData();

            }).catch(err => {
                setTopics([]);
                setLoaderDisplay(false);
            });
    };

    const getAllSelectedData = () => {
        MaterialIssueService.getSelOmitData(filter.year, 0, companyId, filter.category, true).then(res => {
            if (res.status !== 200) return;
            setSelectedDataDetails(res.data.topics ?? []);
        }).catch(err => {
        });
    };

    const getAllOmittedData = () => {
        MaterialIssueService.getSelOmitData(filter.year, 0, companyId, filter.category, false).then(res => {
            if (res.status !== 200) return;
            setOmittedDataDetails(res.data.topics ?? []);
        }).catch(err => {
        });
    };

    const renderSubTopics = (topic) => {
        // topic?.children?.sort((a, b) => a.name.localeCompare(b.name));
        return (
            <>
                <div className='issuesLIbraryCard_body'>
                    <div className='issuesLIbraryCard_body_in'>

                        {
                            topic?.children?.map((subTopic, topicIndex) => {
                                // subTopic?.children?.sort((a, b) => a.name.localeCompare(b.name));
                                return (
                                    <div className='issuesLIbraryCard_sub' key={subTopic.id || topicIndex}>
                                        <div className='issuesLIbraryCard_subhead'>
                                            <div className='issuesLIbraryCard_subheadIn' onClick={() => toggleTopic(subTopic.id)} >
                                                <span className='Libraryactivebtn'>
                                                    {
                                                        topicVisiblity[subTopic.id] === false
                                                            ? <BiChevronDown />
                                                            : <BiChevronUp />
                                                    }
                                                </span>
                                                <h6>
                                                    {/* {subTopic.name} */}
                                                    {(i18n.language && subTopic[i18n.language]) ? subTopic[i18n.language] : subTopic.name}

                                                </h6>
                                            </div>

                                            <div className='issuesLIbraryCard_subheadIn02'>
                                                {canEditTopic(subTopic) && (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(
                                                            t('Custom.label')
                                                        )}>
                                                        <span className='custom_tag_img'><img src={custom_tag} alt="custom_tag" /></span>
                                                    </OverlayTrigger>
                                                )}
                                                {
                                                    (getAttemptedSubSubTopicCount(subTopic.children) !== 0 && getAttemptedSubSubTopicCount(subTopic.children) == subTopic.children.length) &&
                                                    <span className='select_status02 badge bg-badge-Finalized rounded-pill'>{getAttemptedSubSubTopicCount(subTopic.children)}/{subTopic.children.length}</span>
                                                }
                                                {
                                                    getAttemptedSubSubTopicCount(subTopic.children) > 0 && getAttemptedSubSubTopicCount(subTopic.children) < subTopic.children.length &&
                                                    <span className='select_status02 badge bg-badge-Draft rounded-pill'>{getAttemptedSubSubTopicCount(subTopic.children)}/{subTopic.children.length}</span>
                                                }
                                                {
                                                    getAttemptedSubSubTopicCount(subTopic.children) == 0 &&
                                                    <span className='select_status02 badge bg-badge-New badge-custom rounded-pill'>{getAttemptedSubSubTopicCount(subTopic.children)}/{subTopic.children.length}</span>
                                                }
                                                <div className='issuesLIbraryCard_subheadIn_btn02'>
                                                    {(viewType == 'edit' && status != 'FINALIZED') && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(t('AddSubSubTopic.label'))}>
                                                            <Button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                onClick={() => handleAddSubSubTopic(topic, subTopic)}
                                                            >
                                                                <BiPlus className="font-16" />
                                                                {/* {t("AddSubSubTopic.label")} */}
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )}
                                                    {(viewType == 'edit' && status != 'FINALIZED' && canEditTopic(subTopic)) && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(t('EditSubTopic.label'))}>
                                                            <Button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                onClick={() => handleEditSubTopic(topic, subTopic)}
                                                            >
                                                                <BiPencil />
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )}
                                                    {(viewType == 'edit' && status != 'FINALIZED' && canEditTopic(subTopic)) && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(t('Delete.label'))}>
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteSubTopic(topic, subTopic)}
                                                                className="ms-1"
                                                            >
                                                                <BiTrash />
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )}
                                                    {(viewType == 'edit' && status != 'FINALIZED') && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(t('OmitSubTopic.label'))}>
                                                            <span className='closeOmit_btn' onClick={() => { setBulkOmitType({ type: 'sub topic', index: topicIndex }); setBulkOmitData(topic); setShowConfirmation(true) }}><BiX /></span>
                                                        </OverlayTrigger>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        <div className='issuesLIbraryCard_subbody'>
                                            <div className='row mx-0'>
                                                {
                                                    topicVisiblity[subTopic.id] !== false &&
                                                    subTopic?.children?.map((subSubTopic, sIndex) => {
                                                        return (
                                                            <div key={subSubTopic.id || `subSubTopic-${topicIndex}-${sIndex}`} className={`${showDetailsTab ? 'col-lg-4 col-md-4' : 'col-lg-3 col-md-4'} p-2`}>

                                                                <div
                                                                    className={`card p-3 Single_MIC01 ${selectedData.includes(subSubTopic.id)
                                                                        ? 'SelectdMat '
                                                                        : omittedData.includes(subSubTopic.id)
                                                                            ? 'SelectdMat'
                                                                            : ''
                                                                        }`}
                                                                >

                                                                    {/* <div className={`card p-3 Single_MIC01 ${(selectedData.includes(subSubTopic.id) || omittedData.includes(subSubTopic.id)) ? 'SelectdMat' : ''}`}> */}
                                                                    {/* add classs SelectdMat */}
                                                                    <div className='Single_MIC01_in' onClick={() => { openDetailsModal(subSubTopic); onTopicSelect(topic, subTopic, subSubTopic) }}>
                                                                        <div className='Single_MIC01-head' >
                                                                            {subSubTopic.category === 'ENVIRONMENTAL' && (
                                                                                <div className="Single_MIC01_img environmentalimg">
                                                                                    <img src={environmental} />
                                                                                </div>
                                                                            )}
                                                                            {subSubTopic.category === 'SOCIAL' && (
                                                                                <div className="Single_MIC01_img Socialimg">
                                                                                    <img src={social} />
                                                                                </div>
                                                                            )}
                                                                            {subSubTopic.category === 'GOVERNANCE' && (
                                                                                <div className="Single_MIC01_img governanceimg">
                                                                                    <img src={governance} />
                                                                                </div>
                                                                            )}
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={Utils.renderTooltip(
                                                                                    i18n.language && subSubTopic[i18n.language]
                                                                                        ? subSubTopic[i18n.language]
                                                                                        : subSubTopic.name
                                                                                )}>
                                                                                <h6>
                                                                                    {(i18n.language && subSubTopic[i18n.language] && subSubTopic[i18n.language]) ? subSubTopic[i18n.language] : subSubTopic.name}
                                                                                    {/* {subSubTopic.name.length > 60 ? subSubTopic.name.substring(0, 60) + '...' : subSubTopic.name} */}
                                                                                </h6>
                                                                            </OverlayTrigger>
                                                                            <p>
                                                                                {
                                                                                    (i18n.language && subSubTopic[`${i18n.language}_description`])
                                                                                        ? (subSubTopic[`${i18n.language}_description`]?.length > 50
                                                                                            ? subSubTopic[`${i18n.language}_description`].substring(0, 60) + '...'
                                                                                            : subSubTopic[`${i18n.language}_description`])
                                                                                        : (subSubTopic.description?.length > 50
                                                                                            ? subSubTopic.description.substring(0, 60) + '...'
                                                                                            : subSubTopic.description)
                                                                                }
                                                                                {/* {subSubTopic?.description?.length > 50 ? subSubTopic?.description?.substring(0, 60) + '...' : subSubTopic?.description} */}

                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='comment_singleMateriality'>

                                                                        {
                                                                            (viewType == 'edit' && status != 'FINALIZED') &&

                                                                            <ul>
                                                                                {canEditTopic(subSubTopic) && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={Utils.renderTooltip(
                                                                                            t('EditSubSubTopic.label')
                                                                                        )}>
                                                                                        <li onClick={() => handleEditSubSubTopic(topic, subTopic, subSubTopic)}>
                                                                                            <BiPencil className='font-22' />
                                                                                        </li>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                                {canEditTopic(subSubTopic) && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={Utils.renderTooltip(
                                                                                            t('Delete.label')
                                                                                        )}>
                                                                                        <li onClick={() => handleDeleteSubSubTopic(topic, subTopic, subSubTopic)}>
                                                                                            <BiTrash className='font-22' />
                                                                                        </li>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={Utils.renderTooltip(
                                                                                        t('Select.label')
                                                                                    )}>
                                                                                    <li variant="primary" onClick={() => { handleShowSelect(); onTopicSelect(topic, subTopic, subSubTopic) }} >
                                                                                        <BiCheck className='font-22' />
                                                                                    </li>
                                                                                </OverlayTrigger>
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={Utils.renderTooltip(
                                                                                        t('Omit.label')
                                                                                    )}>
                                                                                    <li onClick={() => { handleShowOmit(); onTopicSelect(topic, subTopic, subSubTopic); setOmitType('SubSubTopic'); }}>
                                                                                        <BiX className='font-22' />
                                                                                    </li>
                                                                                </OverlayTrigger>
                                                                            </ul>
                                                                        }
                                                                        {canEditTopic(subSubTopic) && (
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={Utils.renderTooltip(
                                                                                    t('Custom.label')
                                                                                )}>
                                                                                <span className='custom_sub_sub_tag'><img src={custom_tag} alt="custom_tag" /></span>
                                                                            </OverlayTrigger>
                                                                        )}
                                                                        {
                                                                            selectedData.includes(subSubTopic.id) &&
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={Utils.renderTooltip(
                                                                                    t('Selected.label')
                                                                                )}>
                                                                                <span className='SelMat-icon text-success'><BiCheckCircle /></span>
                                                                            </OverlayTrigger>
                                                                        }
                                                                        {
                                                                            omittedData.includes(subSubTopic.id) &&
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={Utils.renderTooltip(
                                                                                    t('Omitted.label')
                                                                                )}>
                                                                                <span className='SelMat-icon text-danger'><BiXCircle /></span>
                                                                            </OverlayTrigger>
                                                                        }
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

            </>
        )
    };

    const toggleTopic = (topicId) => {
        const t = JSON.parse(JSON.stringify(topicVisiblity));
        t[topicId] = t[topicId] !== false ? false : !t[topicId];
        setTopicVisiblity(t);
    };

    const openDetailsModal = (subSubTopic) => {
        handleDescShow();
        // setTopicDetails(subSubTopic);
    }

    const onTopicSelect = (topic, subTopic, subSubTopic) => {
        setTopicDetails(subSubTopic);
        const selectedTopicData = structuredClone(selectedTopics);
        const matchingIndex = selectedTopicData.topicIds.indexOf(subSubTopic.id);
        if (matchingIndex >= 0) {
            selectedTopicData.topicIds.splice(matchingIndex, 1);
            const tIndex = selectedTopicData.topics?.findIndex(t => t.id === topic.id);
            if (tIndex >= 0) {
                const subTopicIndex = selectedTopicData.topics[tIndex].children?.findIndex(t => t.id === subTopic.id);
                if (subTopicIndex >= 0) {
                    const subSubTopicIndex = selectedTopicData.topics[tIndex].children[subTopicIndex].children?.findIndex(t => t.id === subSubTopic.id);
                    if (subSubTopicIndex >= 0) {
                        selectedTopicData.topics[tIndex].children[subTopicIndex].children.splice(subSubTopicIndex, 1);
                        if (selectedTopicData.topics[tIndex].children[subTopicIndex].children?.length === 0) {
                            // If there is none left then remove the whole subtopic
                            selectedTopicData.topics[tIndex].children.splice(subTopicIndex, 1);
                            if (selectedTopicData.topics[tIndex].children?.length === 0) {
                                // If there is none left then remove the whole topic
                                selectedTopicData.topics.splice(tIndex, 1);
                            }
                        }
                    }
                }
            }
        } else {
            selectedTopicData.topicIds.push(subSubTopic.id);
            const tIndex = selectedTopicData.topics?.findIndex(t => t.id === topic.id);
            if (tIndex >= 0) {
                const subTopicIndex = selectedTopicData.topics[tIndex].children?.findIndex(t => t.id === subTopic.id);
                if (subTopicIndex >= 0) {
                    selectedTopicData.topics[tIndex].children[subTopicIndex].children.push(subSubTopic);
                } else {
                    const subTopicClone = {
                        ...subTopic,
                        children: []
                    };
                    subTopicClone.children.push(subSubTopic);
                    selectedTopicData.topics[tIndex].children.push(subTopicClone);
                }
            } else {
                const tClone = {
                    ...topic,
                    children: []
                };
                const subTopicClone = {
                    ...subTopic,
                    children: []
                };
                subTopicClone.children.push(subSubTopic);
                tClone.children.push(subTopicClone);
                selectedTopicData.topics.push(tClone);
            }
        }
        processTopicToSend(selectedTopicData.topics);
    };


    const getCompanyLanguages = () => {
        CompanyService.getCompanyLanguageList()
            .then((response) => {
                if (response.status === 200) {
                    const primaryLanguage = response.data.find(lang => lang.primary === true);
                    setPrimaryLanguageCode(primaryLanguage.code);
                }
            })
            .catch((error) => { });
    }

    const processTopicToSend = (topicData) => {
        let tDataClone = JSON.parse(JSON.stringify(topicData));
        if (filter.category) {
            tDataClone = tDataClone.filter(t => t.category === filter.category);
        }
        // Refine
        tDataClone?.forEach(topicToAdd => {
            topicToAdd['masterRef'] = topicToAdd.id;
            delete topicToAdd.id;
            delete topicToAdd.parentId;
            topicToAdd?.children?.forEach(subTopicToAdd => {
                subTopicToAdd['masterRef'] = subTopicToAdd.id;
                delete subTopicToAdd.id;
                delete subTopicToAdd.parentId;
                subTopicToAdd?.children?.forEach(subSubTopicToAdd => {
                    subSubTopicToAdd['masterRef'] = subSubTopicToAdd.id;
                    delete subSubTopicToAdd.id;
                    delete subSubTopicToAdd.parentId;
                });
            });
        });
        setSelectedSubSubTopic(tDataClone);
    };

    const saveSelectScores = (e) => {
        e.preventDefault();
        if (materialityType == 'Single') {
            if (importanceImpact.scale == '' || importanceImpact.reason == '' || materialityImpact.scale == '' || materialityImpact.reason == '') {
                setValidatedGroupSelect(true);
                toast.warning(t('ChooseMandatoryMessage.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            };
        } else {
            if (financialImpact.reason == '' || financialImpact.range == '' || financialImpact.likelihood == '' || materialityImpact.reason == ''
                || materialityImpact.likelihood == '' || materialityImpact.scale == '' || materialityImpact.scope == '' || materialityImpact.irremediability == '') {
                setValidatedGroupSelect(true);
                toast.warning(t('ChooseMandatoryMessage.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            };
        }
        let transformedObjectToSend = [];
        if (primaryLanguageCode) {
            transformedObjectToSend = transformObjectToSend(selectedSubSubTopic[0]);
        } else {
            transformedObjectToSend = selectedSubSubTopic[0];
        }
        if (materialityType == 'Single') {
            let matDataToSend = {
                type: "IMPACT",
                scale: materialityImpact.scale,
                reason: materialityImpact.reason
            }
            transformedObjectToSend.children[0].children[0]['materialityImpact'] = matDataToSend;
            transformedObjectToSend.children[0].children[0]['importanceImpact'] = importanceImpact;
        }
        else {

            transformedObjectToSend.children[0].children[0]['materialityImpact'] = materialityImpact;
            transformedObjectToSend.children[0].children[0]['financialImpact'] = financialImpact;
        }
        setLoaderDisplay(true);
        MaterialIssueService.saveSelectedData(filter.year, 0, companyId, 0, companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL', transformedObjectToSend).then(res => {
            setLoaderDisplay(false);
            if (res.status !== 200) return;
            toast.success(t('MatIssueSelectSuccessMsg.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            handleCloseSelect();
            setShowDetailsTab(true);
            resetValues();
            onSuccess(res);
            getAllSelectedData();
            getAllOmittedData();
            setActiveTab('selectedBox');
        }).catch(err => {
            setLoaderDisplay(false);
        });
    };

    // Recursive function to transform the object and its children
    const transformObjectToSend = (obj) => {
        const transformedObj = { ...obj };
        const languageKey = primaryLanguageCode;
        const descriptionKey = `${languageKey}_description`;

        if (transformedObj[languageKey] && transformedObj[descriptionKey]) {
            transformedObj.name = transformedObj[languageKey];
            transformedObj.description = transformedObj[descriptionKey];
        }
        // If the object has children, recursively transform them
        if (transformedObj.children) {
            transformedObj.children = transformedObj.children.map(child => transformObjectToSend(child));
        }

        return transformedObj;
    };

    const saveOmitScores = (e) => {
        e.preventDefault();
        if (!omitReason) {
            setValidatedGroupOmit(true);
            toast.warning(t('ChooseMandatoryMessage.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        const passData = selectedSubSubTopic[0];
        let masterRef = 0
        if (omitType == 'Topic') {
            masterRef = passData.masterRef ?? 0;
            passData['comments'] = omitReason;
        } else if (omitType == 'SubTopic') {
            masterRef = passData.children[0].masterRef ?? 0;
            passData.children[0]['comments'] = omitReason;
        } else if (omitType == 'SubSubTopic') {
            masterRef = passData.children[0].children[0].masterRef ?? 0;
            passData.children[0].children[0]['comments'] = omitReason;
        }
        setLoaderDisplay(true);
        MaterialIssueService.saveOmittedData(filter.year, 0, companyId, 0, masterRef, companyInfo.materialTopicCategory ? companyInfo.materialTopicCategory : 'GENERAL', passData).then(res => {
            setLoaderDisplay(false);
            if (res.status !== 200) return;
            toast.success(t('MatIssueOmitSuccessMsg.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            handleCloseOmit();
            setShowDetailsTab(true);
            resetValues();
            onSuccess(res);
            getAllSelectedData();
            getAllOmittedData();
            setActiveTab('omitted');
        }).catch(err => {
            setLoaderDisplay(false);
        });
    };

    const resetValues = () => {
        setFinancialImpact({
            type: "FINANCIAL",
            range: "",
            likelihood: "",
            reason: ""
        });
        setMaterialityImpact({
            type: "IMPACT",
            likelihood: "",
            scale: "",
            scope: "",
            irremediability: "",
            reason: ""
        });
        setImportanceImpact({
            type: "IMPORTANCE",
            scale: "",
            reason: ""
        });
        // setMaterialityType('Single');
        setOmitReason('');
        setSelectedSubSubTopic({});
        setTopicDetails({});
        setOmitType('');
        setValidatedGroupOmit(false);
        setValidatedGroupSelect(false);
        setTitlename('');
        setBulkOmitData({});
        setBulkOmitType({});
    }

    const omitTopicLevel = (topicData) => {
        let tDataClone = JSON.parse(JSON.stringify(topicData));
        // Refine
        tDataClone['masterRef'] = tDataClone.id;
        delete tDataClone.id;
        delete tDataClone.parentId;
        tDataClone?.children?.forEach(subTopicToAdd => {
            subTopicToAdd['masterRef'] = subTopicToAdd.id;
            delete subTopicToAdd.id;
            delete subTopicToAdd.parentId;
            subTopicToAdd?.children?.forEach(subSubTopicToAdd => {
                subSubTopicToAdd['masterRef'] = subSubTopicToAdd.id;
                delete subSubTopicToAdd.id;
                delete subSubTopicToAdd.parentId;
            });
        });
        setSelectedSubSubTopic([tDataClone]);
        setOmitType('Topic');
        setTitlename(tDataClone);
        handleShowOmit();
    }

    const omitSubTopicLevel = (topicData, topicIndex) => {
        let tDataClone = JSON.parse(JSON.stringify(topicData));
        // Refine
        tDataClone['masterRef'] = tDataClone.id;
        delete tDataClone.id;
        delete tDataClone.parentId;
        tDataClone.children.splice(0, tDataClone.children.length, tDataClone.children[topicIndex]);
        tDataClone?.children?.forEach(subTopicToAdd => {
            subTopicToAdd['masterRef'] = subTopicToAdd.id;
            delete subTopicToAdd.id;
            delete subTopicToAdd.parentId;
            subTopicToAdd?.children?.forEach(subSubTopicToAdd => {
                subSubTopicToAdd['masterRef'] = subSubTopicToAdd.id;
                delete subSubTopicToAdd.id;
                delete subSubTopicToAdd.parentId;
            });
        });
        setSelectedSubSubTopic([tDataClone]);
        setTitlename(tDataClone?.children[0]);
        setOmitType('SubTopic');
        handleShowOmit();
    }

    const collapseAll = (topic) => {
        const t = JSON.parse(JSON.stringify(topicVisiblity));
        topic.children.forEach(element => {
            t[element.id] = t[element.id] !== false ? false : !t[element.id];;
        });
        setTopicVisiblity(t);
    }

    const getAttemptedSubSubTopicCount = (subSubTopics) => {
        return subSubTopics.filter(s => selectedData.includes(s.id) || omittedData.includes(s.id))?.length ?? 0;
    };

    const getAttemptedSubTopicCount = (subTopics) => {
        let attemtedSubTopicCount = 0;
        subTopics?.forEach(subTopic => {
            attemtedSubTopicCount += (subTopic?.children?.filter(s => selectedData.includes(s.id) || omittedData.includes(s.id))?.length ?? 0) > 0 ? 1 : 0;
        });
        return attemtedSubTopicCount;
    };

    // Helper function to check if current company can edit a topic
    const canEditTopic = (topic) => {
        return topic?.companyRef === currentCompanyId;
    };

    // Filter topics to show only own topics (with companyRef)
    const filterOwnTopics = (topicsData) => {
        if (!showOwnTopicsOnly) {
            return topicsData;
        }

        return topicsData.filter(topic => {
            // Check if topic itself has companyRef
            if (topic.companyRef) {
                return true;
            }

            // Check if any subtopic has companyRef
            const hasOwnSubTopics = topic.children?.some(subTopic => {
                if (subTopic.companyRef) {
                    return true;
                }
                // Check if any sub-subtopic has companyRef
                return subTopic.children?.some(subSubTopic => subSubTopic.companyRef);
            });

            return hasOwnSubTopics;
        }).map(topic => {
            // If topic itself doesn't have companyRef, filter its children
            if (!topic.companyRef) {
                const filteredChildren = topic.children?.filter(subTopic => {
                    if (subTopic.companyRef) {
                        return true;
                    }
                    // Check if any sub-subtopic has companyRef
                    const hasOwnSubSubTopics = subTopic.children?.some(subSubTopic => subSubTopic.companyRef);
                    if (hasOwnSubSubTopics) {
                        // Filter sub-subtopics to show only those with companyRef
                        subTopic.children = subTopic.children.filter(subSubTopic => subSubTopic.companyRef);
                        return true;
                    }
                    return false;
                });
                return { ...topic, children: filteredChildren };
            }
            return topic;
        });
    };

    const tabChange = (key) => {
        setActiveTab(key);
    }

    const confirmOmit = (val) => {
        setShowConfirmation(false);
        if (val) {
            if (bulkOmitType.type == 'topic') {
                omitTopicLevel(bulkOmitData);
            } else if (bulkOmitType.type == 'sub topic') {
                omitSubTopicLevel(bulkOmitData, bulkOmitType.index)
            }
        }
    };

    // Modal handlers for topic management
    const handleAddTopic = () => {
        setModalAction('ADD_TOPIC');
        setSelectedParentTopic(null);
        setSelectedParentSubTopic(null);
        setSelectedTopicForEdit(null);
        setShowTopicModal(true);
    };

    const handleAddSubTopic = (topic) => {
        setModalAction('ADD_SUBTOPIC');
        setSelectedParentTopic(topic);
        setSelectedParentSubTopic(null);
        setSelectedTopicForEdit(null);
        setShowTopicModal(true);
    };

    const handleAddSubSubTopic = (topic, subTopic) => {
        setModalAction('ADD_SUBSUBTOPIC');
        setSelectedParentTopic(topic);
        setSelectedParentSubTopic(subTopic);
        setSelectedTopicForEdit(null);
        setShowTopicModal(true);
    };

    const handleEditTopic = (topic) => {
        setModalAction('EDIT_TOPIC');
        setSelectedParentTopic(null);
        setSelectedParentSubTopic(null);
        setSelectedTopicForEdit(topic);
        setShowTopicModal(true);
    };

    const handleEditSubTopic = (topic, subTopic) => {
        setModalAction('EDIT_SUBTOPIC');
        setSelectedParentTopic(topic);
        setSelectedParentSubTopic(null);
        setSelectedTopicForEdit(subTopic);
        setShowTopicModal(true);
    };

    const handleEditSubSubTopic = (topic, subTopic, subSubTopic) => {
        setModalAction('EDIT_SUBSUBTOPIC');
        setSelectedParentTopic(topic);
        setSelectedParentSubTopic(subTopic);
        setSelectedTopicForEdit(subSubTopic);
        setShowTopicModal(true);
    };

    const handleModalClose = () => {
        setShowTopicModal(false);
        setModalAction('');
        setSelectedParentTopic(null);
        setSelectedParentSubTopic(null);
        setSelectedTopicForEdit(null);
    };

    const handleModalSuccess = () => {
        getAllTopics();
        onSuccess();
    };

    // Delete handlers
    const handleDeleteTopic = (topic) => {
        setDeleteTopicData(topic);
        setDeleteType('topic');
        setShowDeleteConfirmation(true);
    };

    const handleDeleteSubTopic = (topic, subTopic) => {
        setDeleteTopicData({ topic, subTopic });
        setDeleteType('subTopic');
        setShowDeleteConfirmation(true);
    };

    const handleDeleteSubSubTopic = (topic, subTopic, subSubTopic) => {
        setDeleteTopicData({ topic, subTopic, subSubTopic });
        setDeleteType('subSubTopic');
        setShowDeleteConfirmation(true);
    };

    const handleDeleteConfirmation = (confirmed) => {
        setShowDeleteConfirmation(false);
        if (confirmed && deleteTopicData) {
            performDelete();
        }
        setDeleteTopicData(null);
        setDeleteType('');
    };

    const performDelete = () => {
        if (!deleteTopicData) return;

        let topicId = null;
        let companyRef = currentCompanyId;

        switch (deleteType) {
            case 'topic':
                topicId = deleteTopicData.id;
                break;
            case 'subTopic':
                topicId = deleteTopicData.subTopic.id;
                break;
            case 'subSubTopic':
                topicId = deleteTopicData.subSubTopic.id;
                break;
            default:
                return;
        }

        setLoaderDisplay(true);
        MaterialIssueService.deleteTopic(topicId, companyRef)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;

                toast.success(t('TopicDeletedSuccessfully.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                getAllTopics();
                onSuccess();
            })
            .catch(err => {
                setLoaderDisplay(false);
                toast.error(t('ErrorOccurred.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const renderFilter = () => {
        return (
            <div className={filterDisplay ? '' : 'd-none'}>
                <CustomTopicFilter
                    showOwnTopicsOnly={showOwnTopicsOnly}
                    onApplyFilter={(filterData) => {
                        setShowOwnTopicsOnly(filterData.showOwnTopicsOnly);
                    }}
                    onFilterHide={(value) => setFilterDisplay(value)}
                />
            </div>
        );
    };

    return (
        <>
            <div className='row m-0'>
                <div className={`${showDetailsTab ? 'issuesLIbraryCard_09 col-md-9' : 'issuesLIbraryCard_12 col-md-12'} p-2 pb-0`}>
                    <div className='showDetailsHead'>
                        <p>{t('IdentifyMaterialIssueslibraryTitle.label')}</p>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div>
                                {
                                    !showDetailsTab &&
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={Utils.renderTooltip('Show selected/omitted details')}>
                                        <button className='btn  showDetailsTab_btn' onClick={() => setShowDetailsTab(true)}>
                                            {t("Show.label")}
                                        </button>
                                    </OverlayTrigger>
                                }
                            </div>
                            <div className="d-flex align-items-center gap-3">
                                <CustomTopicFilterStatus
                                    showOwnTopicsOnly={showOwnTopicsOnly}
                                    onFilterClick={() => setFilterDisplay(!filterDisplay)}
                                />
                                {(viewType == 'edit' && status != 'FINALIZED') && (
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={handleAddTopic}
                                        className="me-2"
                                    >
                                        <BiPlus />
                                        {t("ReportPrompting.topic.label")}
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                    {renderFilter()}
                    {/* <Button variant='primary' onClick={() => setShowDetailsTab(true)}> Show Tabs</Button> */}
                    {
                        filterOwnTopics(topics)?.map((topic, index) => {
                            return (
                                <>
                                    <div className={`issuesLIbraryCard 
                                        ${topic.category === 'ENVIRONMENTAL' ? 'Environmentalcard' :
                                            topic.category === 'SOCIAL' ? 'socialCard' :
                                                topic.category === 'GOVERNANCE' ? 'Governancecard' : ''}`} key={topic.id || index}>

                                        <Fragment key={`topic-${index}`}>
                                            <div className='issuesLIbraryCard_head'>
                                                <div className='issuesLIbraryCard_head_inner'>
                                                    {/* <span className='Libraryactivebtn'>
                                                        <BiChevronDown />
                                                    </span> */}
                                                    <h6>{(i18n.language && topic[i18n.language]) ? topic[i18n.language] : topic.name}</h6>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(
                                                            t('CollapseOrExpand.label')
                                                        )}>
                                                        <span className='all_collapseBtn' onClick={() => collapseAll(topic)}>
                                                            <BiCollapseVertical />
                                                        </span>
                                                    </OverlayTrigger>
                                                </div>
                                                <div className='issuesLIbraryCard_head_inner02'>
                                                    {canEditTopic(topic) && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(
                                                                t('Custom.label')
                                                            )}>
                                                            <span className='custom_tag_img'><img src={custom_tag} alt="custom_tag" /></span>
                                                        </OverlayTrigger>
                                                    )}
                                                    {
                                                        (getAttemptedSubTopicCount(topic.children) !== 0 && getAttemptedSubTopicCount(topic.children) == topic.children.length) &&
                                                        <span className='select_status02 badge bg-badge-Finalized rounded-pill'>
                                                            {t('Completed.label')}</span>
                                                    }
                                                    {
                                                        (getAttemptedSubTopicCount(topic.children) > 0 && getAttemptedSubTopicCount(topic.children) < topic.children.length) &&
                                                        <span className='select_status02 badge bg-badge-Draft  rounded-pill'>{t('InProgress.label')}</span>
                                                    }
                                                    {
                                                        getAttemptedSubTopicCount(topic.children) == 0 &&
                                                        <span className='select_status02 badge bg-badge-New badge-custom rounded-pill'>{t('NotStarted.label')}</span>
                                                    }

                                                    <div className='issuesLIbraryCard_head_innerbtn02'>
                                                        {(viewType == 'edit' && status != 'FINALIZED') && (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={Utils.renderTooltip(t('AddSubTopic.label'))}>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    onClick={() => handleAddSubTopic(topic)}
                                                                >
                                                                    <BiPlus />
                                                                    {/* {t("AddSubTopic.label")} */}
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}
                                                        {(viewType == 'edit' && status != 'FINALIZED' && canEditTopic(topic)) && (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={Utils.renderTooltip(t('EditTopic.label'))}>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    onClick={() => handleEditTopic(topic)}
                                                                >
                                                                    <BiPencil />
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}
                                                        {(viewType == 'edit' && status != 'FINALIZED' && canEditTopic(topic)) && (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={Utils.renderTooltip(t('Delete.label'))}>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => handleDeleteTopic(topic)}
                                                                    className="ms-1"
                                                                >
                                                                    <BiTrash />
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}
                                                        {(viewType == 'edit' && status != 'FINALIZED') && (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={Utils.renderTooltip(t('OmitTopic.label'))}>
                                                                <span className='closeOmit_btn' onClick={() => { setBulkOmitType({ type: 'topic', index: null }); setBulkOmitData(topic); setShowConfirmation(true) }}><BiX /></span>
                                                            </OverlayTrigger>
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                            {renderSubTopics(topic)}
                                        </Fragment >

                                    </div >
                                </>
                            )
                        })
                    }
                </div >

                {
                    showDetailsTab &&
                    <div className='col-md-3 p-2'>
                        <div className='selectMatissue_showCard 1'>
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(key) => tabChange(key)}
                                id="uncontrolled-tab-example"
                                className="">
                                <Tab eventKey="selectedBox" className='selectedBox_issue' title={<> {t('Selected.label')} </>}>
                                    <div className='p-2'>
                                        {
                                            selectedDataDetails?.map((topic, index) => {
                                                return (
                                                    <div className={`card SMICard025 
                                                        ${topic.category === 'ENVIRONMENTAL' ? 'Environmentalcard' :
                                                            topic.category === 'SOCIAL' ? 'socialCard' :
                                                                topic.category === 'GOVERNANCE' ? 'Governancecard' : ''}`} key={topic.id || index}>
                                                        <div className='SMICard025_topic'>
                                                            <div className='SMICard025_topicHead'>
                                                                <span><BiChevronDown /></span>
                                                                {topic?.name}
                                                            </div>
                                                            <div className='SMICard025_topicbody'>
                                                                {
                                                                    topic.children?.map((subtopic, subIndex) => {
                                                                        return (
                                                                            <div className='SMICard025_sub' key={subtopic.id || subIndex}>
                                                                                <div className='SMICard025_subhead'>
                                                                                    <span><BiChevronDown /></span>
                                                                                    {subtopic?.name}
                                                                                </div>
                                                                                <div className='SMICard025_subBody'>
                                                                                    {
                                                                                        subtopic.children?.map((subsubtopic, subSubIndex) => {
                                                                                            return (
                                                                                                <div className='SMICard025_sub02 cursor' key={subsubtopic.id || subSubIndex} onClick={() => { openDetailsModal(subsubtopic); setTopicDetails({ name: subsubtopic.name, id: subsubtopic.masterRef, description: subsubtopic.description, category: subsubtopic.category }); }}>
                                                                                                    <span><BiSolidCircle /></span>
                                                                                                    {subsubtopic?.name}
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </Tab>
                                <Tab eventKey="omitted" className='omitted_issues' title={<> {t('Omitted.label')} </>}>
                                    <div className='p-2'>
                                        {
                                            omittedDataDetails?.map((topic, index) => {
                                                return (
                                                    <div className={`card SMICard025 
                                                        ${topic.category === 'ENVIRONMENTAL' ? 'Environmentalcard' :
                                                            topic.category === 'SOCIAL' ? 'socialCard' :
                                                                topic.category === 'GOVERNANCE' ? 'Governancecard' : ''}`} key={topic.id || index}>
                                                        <div className='SMICard025_topic'>
                                                            <div className='SMICard025_topicHead'>
                                                                <span><BiChevronDown /></span>
                                                                {topic?.name}
                                                            </div>
                                                            <div className='SMICard025_topicbody'>
                                                                {
                                                                    topic.children?.map((subtopic, subIndex) => {
                                                                        return (
                                                                            <div className='SMICard025_sub' key={subtopic.id || subIndex}>
                                                                                <div className='SMICard025_subhead'>
                                                                                    <span><BiChevronDown /></span>
                                                                                    {subtopic?.name}
                                                                                </div>
                                                                                <div className='SMICard025_subBody'>
                                                                                    {
                                                                                        subtopic.children?.map((subsubtopic, subSubIndex) => {
                                                                                            return (
                                                                                                <div className='SMICard025_sub02 cursor' key={subsubtopic.id || subSubIndex} onClick={() => { openDetailsModal(subsubtopic); setTopicDetails({ name: subsubtopic.name, id: subsubtopic.masterRef, description: subsubtopic.description, category: subsubtopic.category }); }}>
                                                                                                    <span><BiSolidCircle /></span>
                                                                                                    {subsubtopic?.name}
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </Tab>
                            </Tabs>

                            <button className='SHowCard_close' onClick={() => setShowDetailsTab(false)}><BiX /></button>

                        </div>
                    </div>
                }
            </div >

            <Modal show={showDescriptionModal}
                onHide={handleDescClose}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered>
                <Modal.Header closeButton className='bg-white border-0 pt-3 SMHead014'>
                    <Modal.Title bsPrefix="modal-title" as="h5" className='pt-3 px-3 w-100'>
                        <div className='Single_MIC01_02'>
                            {topicDetails.category === 'ENVIRONMENTAL' && (
                                <div className="Single_MIC01_img_02 environmentalimg">
                                    <img src={environmental} />
                                </div>
                            )}
                            {topicDetails.category === 'SOCIAL' && (
                                <div className="Single_MIC01_img_02 Socialimg">
                                    <img src={social} />
                                </div>
                            )}
                            {topicDetails.category === 'GOVERNANCE' && (
                                <div className="Single_MIC01_img_02 governanceimg">
                                    <img src={governance} />
                                </div>
                            )}
                            {(i18n.language && topicDetails[i18n.language]) ? topicDetails[i18n.language] : topicDetails.name}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='pb-3'>
                        <div className=''>
                            <p>
                                {(i18n.language && topicDetails[`${i18n.language}_description`])
                                    ? topicDetails[`${i18n.language}_description`]
                                    : topicDetails?.description
                                }
                            </p>
                        </div>
                        {
                            (!selectedData.includes(topicDetails.id) && !omittedData.includes(topicDetails.id)) &&
                            <div className='text-center pt-3 '>
                                <Button variant="secondary"
                                    className='me-2 px-3'
                                    onClick={() => {
                                        setShowDescriptionModal(false);
                                        setOmitType('SubSubTopic');
                                        handleShowOmit();
                                    }}>
                                    <BiX className='font-22' />	{t("Omit.label")}
                                </Button>
                                <Button variant="primary" className='px-3' onClick={() => {
                                    setShowDescriptionModal(false);
                                    handleShowSelect();
                                }}>
                                    <BiCheck className='font-22' />	{t("Select.label")}
                                </Button>
                            </div>
                        }
                    </div>
                </Modal.Body>
            </Modal>


            <Modal show={showOmitModal}
                onHide={handleCloseOmit}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton className='border-0  SMHead014 '>
                    <Modal.Title bsPrefix="modal-title" as="h5" className='pt-3 px-3 w-100'>
                        <div className='Single_MIC01_02 '>
                            {(topicDetails.category === 'ENVIRONMENTAL' || titlename.category === 'ENVIRONMENTAL') && (
                                <div className="Single_MIC01_img_02 environmentalimg">
                                    <img src={environmental} />
                                </div>
                            )}
                            {(topicDetails.category === 'SOCIAL' || titlename.category === 'SOCIAL') && (
                                <div className="Single_MIC01_img_02 Socialimg">
                                    <img src={social} />
                                </div>
                            )}
                            {(topicDetails.category === 'GOVERNANCE' || titlename.category === 'GOVERNANCE') && (
                                <div className="Single_MIC01_img_02 governanceimg">
                                    <img src={governance} />
                                </div>
                            )}

                            {(i18n.language && topicDetails[i18n.language])
                                ? topicDetails[i18n.language]
                                : topicDetails?.name ?? titlename.name}
                            <OverlayTrigger
                                placement="bottom"
                                overlay={Utils.renderTooltip(
                                    (i18n.language && topicDetails[`${i18n.language}_description`])
                                        ? topicDetails[`${i18n.language}_description`]
                                        : topicDetails?.description
                                )}>
                                <span className='ms-2'><BiInfoCircle /></span>
                            </OverlayTrigger>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate validated={validatedGroupOmit}>
                        <div className='pb-3'>
                            <div className='mb-2'>
                                <label>{t('ReasonForOmittingText.label')} <span className='text-danger'>*</span></label>
                                <textarea className='form-control' rows={5}
                                    value={omitReason}
                                    onChange={(e) => setOmitReason(e.target.value)}
                                    required
                                    maxLength={2000}>
                                </textarea>
                            </div>

                            <div className='text-center pt-3 '>
                                <Button variant="secondary" className='me-2 px-3' onClick={() => {
                                    handleCloseOmit();
                                }}>
                                    {t("Close.label")}
                                </Button>
                                <Button variant="primary" className='px-3' onClick={(e) => {
                                    saveOmitScores(e);
                                }}>
                                    {t("Save.label")}
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <MaterialityImpactSelectionModal
                t={t}
                validated={validatedGroupSelect}
                mode="EDIT"
                topicDetails={topicDetails}
                financialImpact={financialImpact}
                materialityImpact={materialityImpact}
                importanceImpact={importanceImpact}
                onFinancialImpactChange={setFinancialImpact}
                onMaterialityImpactChange={setMaterialityImpact}
                onImportanceImpactChange={setImportanceImpact}
                onClose={handleCloseSelect}
                onSave={saveSelectScores}
                show={showSelectModal}
                materialityType={materialityType}
            />

            {
                showConfirmation &&
                <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={true}
                    messageText={t("BulkOmitMessage.label")}
                    callbackModal={confirmOmit}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            }

            <MaterialIssuesLibraryModal
                show={showTopicModal}
                onHide={handleModalClose}
                action={modalAction}
                topicData={selectedTopicForEdit}
                parentTopic={selectedParentTopic}
                parentSubTopic={selectedParentSubTopic}
                topics={topics}
                onSuccess={handleModalSuccess}
                filter={filter}
            />

            {
                showDeleteConfirmation &&
                <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={true}
                    messageText={t("DeleteTopicConfirmation.label")}
                    callbackModal={handleDeleteConfirmation}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            }
        </>

    )
};

export default withTranslation()(MaterialIssuesLibrary);